import { trackingPageSettingsSchema } from "@redotech/order-tracking-common/tracking-page-definition";
import * as z from "zod";

export const getTrackingPageSettings = {
  name: "getTrackingPageSettings" as const,
  input: z.object({}),
  output: trackingPageSettingsSchema.nullable(),
};
